import { DimensionData } from '~/types/internal-api';

export interface LedgerLinesModel {
    ledgerLines: LedgerLineModel[];
    voucherHeadLine: string;
    canCopyTurnReverseVoucher: boolean;
}

export interface LedgerLineModel {
    journalEntryType: number;
    journalEntryNumber?: number;
    accountNumber: number;
    accountName: string;
    debitCreditNumber?: number;
    text: string;
    vatCode: string;
    balanceInDKK: number;
    currency: string;
    balance: number;
    projectNumber?: number;
    department?: number;
    dimensions?: DimensionData[];
}

export interface EligableJournal {
    key: number;
    value: string;
}

export interface KVTModel {
    eligableJournals: EligableJournal[];
    voucherNumber: string;
    date: Date;
}

export interface LedgerLinesFilter {
    orderBy: number;
    entryId: number;
    attachmentNumber: number;
    date: Date | null;
}

export enum EntryTransactionsColumns {
    Type = 'journalEntryType',
    Account = 'accountNumber',
    CustomerSupplier = 'debitCreditNumber',
    Text = 'text',
    VatCode = 'vatCode',
    Currency = 'currency',
    Amount = 'balance',
    BalanceInDKK = 'balanceInDKK',
    CalculatedBalance = 'calculatedBalance',
    Project = 'projectNumber',
    Dimension1 = 'dimension1',
    Dimension2 = 'dimension2',
    Dimension3 = 'dimension3',
}
